import React from "react";
import "./styles/header.css";
import { NavLink, useNavigation } from "react-router-dom";
import { HiMiniBars3 } from "react-icons/hi2";
import { useSelector } from "react-redux";
import MobileBar from "./MobileBar";

const Header = () => {
  const [openMobileBar, setOpenMobileBar] = React.useState(false);
  const data = [
    {
      id: 1,
      name: "Publisher",
      path: "/",
    },
    {
      id: 2,
      name: "About Us",
      path: "/about",
    },
    {
      id: 3,
      name: "Integrate",
      path: "/integrate",
    },

    {
      id: 4,
      name: "Contact Us",
      path: "/contact",
    },
  ];
console.log(openMobileBar,"openMobileBar")
  return (
    <>
    
    <div className="container header">
    <MobileBar data={data} open={openMobileBar} setOpen={setOpenMobileBar}/>
      <nav>
       
      {!openMobileBar && <div onClick={() => {window.scrollTo(0, 0);window.location.replace('/')}} className="logo"><img src="images/logo.svg" alt="Logo" /></div>}
      {!openMobileBar && <div className="mobile-menu">
       <HiMiniBars3 className="mobile-bar" onClick={() => setOpenMobileBar(true)}></HiMiniBars3>
       <p>Menu</p>
       </div>}
        <div className="navbar-links">
          {data.map((item, index) => {
            return (
              <>
              {index > 0 && <p>|</p>}
              {item.id !== 3 ?<NavLink
                className={({ isActive, isPending }) =>
                  isPending ? "links" : isActive ? "active-link" : "links"
                }
                to={item.path}
              >
                {item.name} 
              </NavLink> : <button className="links integrate-header-btn" onClick={() => {
                  item.id ===3 && (window.open("https://prorewards.gitbook.io/real-opinion") )
                }}>

                {item.name}</button>}
              </>
            );
          })}
        </div>
        <div className="login-header">
          <NavLink className="login-link" onClick={() => {
            window.open("https://publisher.realopinions.ai/login")
          }}>Login</NavLink>
          <button
          onClick={() => {
            window.open("https://publisher.realopinions.ai/register")
          }}
          className="btn-primary">Register</button>
        </div>
      </nav>
    </div>
    </>
  );
};

export default Header;
